<template>
  <el-tabs v-model="activeState" class="demo-tabs" @tab-change="handleClick">
    <el-tab-pane label="待审核申请" :name="0">
      <el-form :inline="true" class="demo-form-inline">
          <el-form-item label="租用类型：">
              <el-select style="width: 200px;" v-model="formInline1.rentalType" filterable placeholder="请选择">
                  <el-option
                  v-for="item in typeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                  </el-option>
              </el-select>
          </el-form-item>
          <!-- <el-form-item label="起租日期：">
            <el-date-picker
                v-model="formInline1.date"
                value-format="YYYY-MM-DD"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
            />
          </el-form-item> -->
          <el-form-item label="关键字：">
              <el-input v-model="formInline1.name" placeholder="请输入租户名称"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searchApply()">搜索</el-button>
          </el-form-item>
      </el-form>
      <el-table class="table_wrapper" :data="tableData1" :header-cell-style="{'text-align':'left'}" :cell-style="{'text-align':'left'}">
        <el-table-column label="ID" width="80">
          <template #default="scope">
            <div>
              <span>{{scope.row.id}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="租户名称" show-overflow-tooltip>
          <template #default="scope">
            <div>
              <span>{{ scope.row.name }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="租户类型" width="150">
          <template #default="scope">
            <div>
              <span>{{ typeFilter(scope.row.type) }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="80">
          <template #default="scope">
            <div>
              <span>{{ statusFilter(scope.row.state) || '--' }}</span>
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column label="租用期限" width="300">
          <template #default="scope">
            <div>
              <span>{{ scope.row.rentalStart || '--' }} 至 {{ scope.row.rentalEnd || '--' }}</span>
            </div>
          </template>
        </el-table-column> -->
        <el-table-column label="租用类型" width="80">
          <template #default="scope">
            <div>
              <span>{{ rentalTypeFilter(scope.row.rentalType) || '--' }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="租用时长（月）" width="130">
          <template #default="scope">
            <div>
              <span>{{ scope.row.rentalTerm || '--' }}</span>
            </div>
          </template>
        </el-table-column>
        
        <el-table-column label="操作" width="200" fixed="right">
          <template #default="scope">
            <el-button type="success" size="small" @click="handleAudit(scope.$index, scope.row)">
              审核
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <Pagination
          v-model:current-page="currentPage1"
          v-model:page-size="pageSize1"
          :total="total1"
          @size-change="handleSizeChange1"
          @current-change="handleCurrentChange1"
      />
    </el-tab-pane>
    <el-tab-pane label="已审核" :name="1">
    <el-form :inline="true" class="demo-form-inline">
          <el-form-item label="状态：">
              <el-select style="width: 200px;" v-model="formInline.state" filterable placeholder="请选择">
                  <el-option
                  v-for="item in stateOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                  </el-option>
              </el-select>
          </el-form-item>
          <el-form-item label="租用类型：">
              <el-select style="width: 200px;" v-model="formInline.rentalType" filterable placeholder="请选择">
                  <el-option
                  v-for="item in typeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                  </el-option>
              </el-select>
          </el-form-item>
          <el-form-item label="起租日期：">
            <el-date-picker
                v-model="formInline.date"
                value-format="YYYY-MM-DD"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
            />
          </el-form-item>
          <el-form-item label="关键字：">
              <el-input v-model="formInline.name" placeholder="请输入租户名称"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="search()">搜索</el-button>
          </el-form-item>
      </el-form>
      <el-table class="table_wrapper" :data="tableData" :header-cell-style="{'text-align':'left'}" :cell-style="{'text-align':'left'}">
        <el-table-column label="ID" width="80">
          <template #default="scope">
            <div>
              <span>{{scope.row.id}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="租户名称" show-overflow-tooltip>
          <template #default="scope">
            <div>
              <span>{{ scope.row.name }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="租户类型" width="150">
          <template #default="scope">
            <div>
              <span>{{ typeFilter(scope.row.type) }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="80">
          <template #default="scope">
            <div>
              <span>{{ statusFilter(scope.row.state) || '--' }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="租用期限" width="300">
          <template #default="scope">
            <div>
              <span>{{ scope.row.rentalStart || '--' }} 至 {{ scope.row.rentalEnd || '--' }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="租用类型" width="80">
          <template #default="scope">
            <div>
              <span>{{ rentalTypeFilter(scope.row.rentalType) || '--' }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="租用时长（月）" width="130">
          <template #default="scope">
            <div>
              <span>{{ scope.row.rentalTerm || '--' }}</span>
            </div>
          </template>
        </el-table-column>
        
        <el-table-column label="操作" width="200" fixed="right">
          <template #default="scope">
            <el-button size="small" @click="handleEdit(scope.$index, scope.row)">
              编辑
            </el-button>
            <el-button type="success" size="small" @click="handleStart(scope.$index, scope.row)" v-if="scope.row.state == 2">
              启用
            </el-button>
            <el-button
              size="small"
              type="danger"
              v-if="scope.row.state == 1"
              @click="handleStop(scope.$index, scope.row)"
            >
              禁用
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <Pagination
          v-model:current-page="currentPage"
          v-model:page-size="pageSize"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
      />
    </el-tab-pane>
    </el-tabs>
    <!-- 审核详情 -->
    <el-drawer
        v-model="drawer"
        title="租户申请审核"
        direction="rtl"
        size="70%"
    >
    <el-form :model="detailData" label-position="right" label-width="auto">
      <el-row>
          <el-col :span="12">
              <el-form-item label="租户名称：" prop="">
                  <div>{{detailData.name}}</div>
              </el-form-item>
          </el-col>
          <el-col :span="12">
              <el-form-item label="统一社会信用代码：" prop="">
                  <div>
                  <span>{{detailData.creditCode || '--'}}</span>
                  </div>
              </el-form-item>
          </el-col>
      </el-row>
      <el-row>
          <el-col :span="12">
              <el-form-item label="注册地址：" prop="">
                  <div>{{detailData.companyAddress || '--'}}</div>
              </el-form-item>
          </el-col>
          <el-col :span="12">
              <el-form-item label="法定代表人：" prop="">
                  <div>
                  <span>{{detailData.cardName || '--'}}</span>
                  </div>
              </el-form-item>
          </el-col>
      </el-row>
      <el-row>
          <el-col :span="12">
              <el-form-item label="成立日期：" prop="">
                  <div>{{detailData.establishDate || '--'}}</div>
              </el-form-item>
          </el-col>
          <el-col :span="12">
              <el-form-item label="经营范围：" prop="">
                  <div>
                  <span>{{detailData.businessScope || '--'}}</span>
                  </div>
              </el-form-item>
          </el-col>
      </el-row>
      <el-row>
          <el-col :span="12">
              <el-form-item label="租户类型：" prop="">
                  <div>{{detailData.type || '--'}}</div>
              </el-form-item>
          </el-col>
          <el-col :span="12">
              <el-form-item label="租用意向：" prop="">
                  <div>
                  <span>{{detailData.rentalType || '--'}}</span>
                  </div>
              </el-form-item>
          </el-col>
      </el-row>
      <el-row>
          <el-col :span="12">
              <el-form-item label="期望租用期限：" prop="">
                  <div>{{detailData.companyAddress || '--'}}</div>
              </el-form-item>
          </el-col>
          <el-col :span="12">
              <el-form-item label="租户编码：" prop="">
                  <div>
                  <span>{{detailData.code || '--'}}</span>
                  </div>
              </el-form-item>
          </el-col>
      </el-row>
      <el-row>
          <el-col :span="12">
              <el-form-item label="申请人：" prop="">
                  <div>{{detailData.applicantName || '--'}}</div>
              </el-form-item>
          </el-col>
          <el-col :span="12">
              <el-form-item label="申请人电话：" prop="">
                  <div>
                  <span>{{detailData.phone || '--'}}</span>
                  </div>
              </el-form-item>
          </el-col>
      </el-row>
      <el-row>
          <el-col :span="12">
              <el-form-item label="公司热线：" prop="">
                  <div>{{detailData.contactNumber || '--'}}</div>
              </el-form-item>
          </el-col>
          <el-col :span="12">
              <el-form-item label="联系邮箱：" prop="">
                  <div>
                  <span>{{detailData.email || '--'}}</span>
                  </div>
              </el-form-item>
          </el-col>
      </el-row>
    </el-form>
    <template #footer>
    <div class="dialog-footer">
        <!-- <el-button @click="closeDrawer">返回</el-button> -->
        <el-button type="primary" @click="submitApply()">审核通过</el-button>
    </div>
    </template>
    </el-drawer>
      <!-- 编辑框 -->
      <el-drawer
          v-model="dialogFormVisible"
          title="编辑租户"
          direction="rtl"
          size="70%"
          :before-close="handleClose"
          @closed="$refs.signInfoRef?.clearValidate()"
      >
          <el-form ref="signInfoRef" :model="signInfo" :rules="signRules" label-position="right" label-width="auto">
          <el-row :gutter="20" style="margin-bottom: 20px;">
            <el-col :span="12">
              <el-form-item label="企业名称" prop="name">
                <el-input v-model="signInfo.name" autocomplete="off" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="统一社会信用代码" prop="creditCode">
                <el-input v-model="signInfo.creditCode" autocomplete="off" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20" style="margin-bottom: 20px;">
            <el-col :span="12">
              <el-form-item label="注册地址" prop="companyAddress">
                <el-input v-model="signInfo.companyAddress" autocomplete="off" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="办公地址" prop="">
                <el-input v-model="signInfo.officeAddress" autocomplete="off" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20" style="margin-bottom: 20px;">
            <el-col :span="8">
              <el-form-item label="法定代表人" prop="cardName">
                <el-input v-model="signInfo.cardName" autocomplete="off" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="成立日期" prop="">
                <el-date-picker
                      v-model="signInfo.establishDate"
                      type="date"
                      value-format="YYYY-MM-DD"
                      placeholder="选择成立日期"
                  >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="经营范围" prop="">
                <el-input v-model="signInfo.businessScope" autocomplete="off" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20" style="margin-bottom: 20px;">
            <el-col :span="8">
              <el-form-item label="租户类型" prop="type">
                <el-select v-model="signInfo.type" placeholder="请选择">
                  <el-option
                      v-for="item in tenantTypeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="租用意向" prop="">
                <el-select v-model="signInfo.rentalType" @change="changeRentalalType" placeholder="请选择">
                  <el-option
                      v-for="item in rentalTypeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="期望租用期限" prop="">
                <el-select v-model="signInfo.rentalTerm" placeholder="请选择">
                  <el-option
                      v-for="item in rentalTermList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20" style="margin-bottom: 20px;">
            <el-col :span="8">
              <el-form-item label="申请人" prop="">
                <el-input v-model="signInfo.applicantName" autocomplete="off" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="申请人电话" prop="">
                <el-input v-model="signInfo.phone" autocomplete="off" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="公司热线" prop="">
                <el-input v-model="signInfo.contactNumber" autocomplete="off" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20" style="margin-bottom: 20px;">
            <el-col :span="8">
              <el-form-item label="联系邮箱" prop="">
                <el-input v-model="signInfo.email" autocomplete="off" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="租户编码" prop="">
                <el-input v-model="signInfo.code" autocomplete="off" disabled />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="租户简称" prop="">
                <el-input v-model="signInfo.merchantAbbreviation" autocomplete="off" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20" style="margin-bottom: 20px;">
            <el-col :span="12">
              <el-form-item label="租用期限" prop="">
                <el-date-picker
                    v-model="signInfo.date"
                    value-format="YYYY-MM-DD"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                />
                  </el-form-item>
            </el-col>
          </el-row>
        
          <el-row>
              <el-col>
                  <el-form-item label="营业执照（加盖公章）：">
                      <el-upload
                          :action="uploadUrl"
                          :headers="headers"
                          :on-success="handleAvatarSuccess"
                          :before-upload="beforeAvatarUpload"
                          list-type="picture-card"
                          limit="1"
                          :class="{ 'hide-upload-btn': certificateList.length >= 1 }"
                          :file-list="certificateList"
                          :on-preview="handlePictureCardPreview"
                          :on-remove="handleRemove">
                          <i class="el-icon-plus">+</i>
                      </el-upload>
                  </el-form-item>
              </el-col>
          </el-row>
          <el-row>
              <el-col>
                  <el-form-item label="法人身份证正反面：">
                      <el-upload
                          :action="uploadUrl"
                          :headers="headers"
                          :on-success="handleAvatarSuccess2"
                          :before-upload="beforeAvatarUpload"
                          list-type="picture-card"
                          limit="2"
                          :class="{ 'hide-upload-btn': cardNoList.length >= 2 }"
                          :file-list="cardNoList"
                          :on-preview="handlePictureCardPreview"
                          :on-remove="handleRemove2">
                          <i class="el-icon-plus">+</i>
                      </el-upload>
                  </el-form-item>
              </el-col>
          </el-row>
          <el-row>
              <el-col>
                  <el-form-item label="银行开户许可证：">
                      <el-upload
                          :action="uploadUrl"
                          :headers="headers"
                          :on-success="handleAvatarSuccess3"
                          :before-upload="beforeAvatarUpload"
                          list-type="picture-card"
                          limit="1"
                          :class="{ 'hide-upload-btn': bankLicenseList.length >= 1 }"
                          :file-list="bankLicenseList"
                          :on-preview="handlePictureCardPreview"
                          :on-remove="handleRemove3">
                          <i class="el-icon-plus">+</i>
                      </el-upload>
                  </el-form-item>
              </el-col>
          </el-row>
          <el-row>
              <el-col>
                  <el-form-item label="签约协议：">
                      <el-upload
                          :action="uploadUrl"
                          :headers="headers"
                          :on-success="handleAvatarSuccess4"
                          :before-upload="beforeAvatarUpload"
                          list-type="picture-card"
                          limit="3"
                          :class="{ 'hide-upload-btn': dateList.length >= 3 }"
                          :file-list="dateList"
                          :on-preview="handlePictureCardPreview"
                          :on-remove="handleRemove4">
                          <i class="el-icon-plus">+</i>
                      </el-upload>
                  </el-form-item>
              </el-col>
          </el-row>
          </el-form>
          <template #footer>
          <div class="dialog-footer">
              <!-- <el-button @click="dialogFormVisible = false">取消</el-button> -->
              <el-button type="primary" @click="saveInfo()">保存</el-button>
          </div>
          </template>
      </el-drawer>

      <!-- 图片预览 -->
      <el-dialog v-model="dialogVisible">
        <img width="100%" :src="dialogImageUrl" alt="">
      </el-dialog>
  
      <!-- 对话框--启用 -->
      <el-dialog
        v-model="centerDialogVisible"
        title="提示"
        width="500"
        align-center
      >
        <span>确定启用该租户吗？</span>
        <template #footer>
          <div class="dialog-footer">
            <el-button @click="centerDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="enableUser()">确定</el-button>
          </div>
        </template>
      </el-dialog>

      <!-- 对话框--禁用 -->
      <el-dialog
        v-model="centerDialogVisible2"
        title="提示"
        width="500"
        align-center
      >
        <span>确定禁用该租户吗？</span>
        <template #footer>
          <div class="dialog-footer">
            <el-button @click="centerDialogVisible2 = false">取消</el-button>
            <el-button type="primary" @click="stopUser()">确定</el-button>
          </div>
        </template>
      </el-dialog>
  
    </template>
    
    <script>
    import { required, isAlphanumeric, noSpecialChar } from '@/utils/validators';
    export default {
    name:'TenantManage',
    data() {
      return {
        tenantTypeList:[
          {
            value:1,
            label:'公司/企业',
          },
          {
            value:2,
            label:'个体工商户',
          },
        ],
        rentalTypeList:[
          {
            value:1,
            label:'月租',
          },
          {
            value:2,
            label:'年租',
          },
        ],
        rentalTermList:[],
        monthList:[
          {
            value:1,
            label:'1个月',
          },
          {
            value:6,
            label:'6个月',
          }
        ],
        yearList:[
          {
            value:12,
            label:'1年',
          },
          {
            value:36,
            label:'3年',
          },
          {
            value:60,
            label:'5年',
          },
        ],
        drawer:false,
        detailData:{},
        activeState: 0,
        isLoadData: false,
        tableData1:[],
        currentPage1: 1, //当前页1
        pageSize1: 10, //每页显示条数1
        total1: 0, //总条数1
        formInline1:{
          rentalType:'',
          date:[],
          name:''
        },
        formInline:{
          state:'',
          rentalType:'',
          date:[],
          name:''
        },
        typeOptions:[
          {
            label:'全部',
            value:''
          },
          {
            label:'月租',
            value:1
          },
          {
            label:'年租',
            value:2
          }
        ],
        stateOptions:[
          {
            label:'全部',
            value:''
          },
          {
            label:'启用',
            value:1
          },
          {
            label:'禁用',
            value:2
          }
        ],
        isUpdate:false,
        dialogFormVisible:false,
        centerDialogVisible:false,
        centerDialogVisible2:false,
        currt_id:'', //当前操作id
        tableData:[],
        signInfoRef: null,
        signRules: {
          name: [required('请输入企业名称'), noSpecialChar('企业名称不能包含特殊字符')],
          creditCode: [required('请输入统一社会信用代码'), isAlphanumeric('统一社会信用代码只能输入数字或字母')],
          companyAddress: [required('请输入注册地址')],
          cardName: [required('请输入法定代表人'), noSpecialChar('法定代表人不能包含特殊字符')],
          type: [required('请选择租户类型')],
        },
        signInfo:{
          name:'',
          type:'',
          rentalTerm:'',
          rentalType:'',
          code:'',
          contactNumber:'',
          email:'',
          certificateUrl:'',
          // merchantAbbreviation:'',
          companyAddress:'',
          // officeAddress:'',
          creditCode:'',
          cardName:'',
          establishDate:'',
          businessScope:'',
          applicantName:'',
          phone:'',
          bankLicense:'XOH90405',
          cardNo:'44030419900101001X',
        },
        total: 0, //总条数
        currentPage: 1, //当前页
        pageSize: 10, //每页显示条数
        uploadUrl:process.env.NODE_ENV === 'development' ? '/api' +this.$store.state.platformApi+"oss/upload" : process.env.VUE_APP_API_URL + '/' + this.$store.state.platformApi+"oss/upload",
        headers: {
          'Authorization': localStorage.getItem('token')
        },
        certificateList:[],
        bankLicenseList:[],
        cardNoList:[],
        dateList:[],
        dialogVisible:false,
        dialogImageUrl:''
      }
    },
    components: {
      
    },
    computed: {
      filteredMessage() {
        // 这里可以实现类似过滤器的转换逻辑
      }
    },
    beforeCreate(){
      
    },
    created(){
      
    },
    mounted(){
      // this.getList();
      this.getListApply();
    },
    methods:{
      changeRentalalType(){
        this.rentalTermList = [];
        this.signInfo.rentalTerm = '';
        if(this.signInfo.rentalType=='1'){
          this.rentalTermList = this.monthList;
        }else{
          this.rentalTermList = this.yearList;
        }
      },
      enableUser(){
        //启用
        let that = this;
        let param = {};
        that.$axios.post(that.$store.state.platformApi+"tenant/auditing/"+that.currt_id+"/1",JSON.stringify(param)).then(result => {
          if(result.code==200){
            that.$message.success('启用成功');
            that.getList();
            that.centerDialogVisible = false;
          }
        })
      },
      stopUser(){
        //禁用
        let that = this;
        let param = {};
        that.$axios.post(that.$store.state.platformApi+"tenant/auditing/"+that.currt_id+"/2",JSON.stringify(param)).then(result => {
          if(result.code==200){
            that.$message.success('禁用成功');
            that.getList();
            that.centerDialogVisible2 = false;
          }
        })
      },
      handleClose(done){
        this.$confirm('此操作不会保存更改哦，确定关闭吗？',{
            confirmButtonText: '确定',
            cancelButtonText: '取消',
        })
        .then(_ => {
            done();
        })
        .catch(_ => {});
      },
      closeDrawer(){
        this.drawer = false;
      },
      handleAudit(index, row){
        //审核
        this.currt_id = row.id;
        this.detailData = row;
        this.drawer = true;
      },
      submitApply(){
        //审核通过
        let that = this;
        let param = {};
        that.$axios.post(that.$store.state.platformApi+"tenant/auditing/"+that.currt_id+"/1",JSON.stringify(param)).then(result => {
          if(result.code==200){
            that.$message.success('审核通过');
            that.getListApply();
            that.closeDrawer();
          }
        })
      },
      handleClick(tab, event) {
          // console.log('点击了tab', this.activeState);
          if(this.activeState == 1 && !this.isLoadData){
              this.getList(); //获取列表
              this.isLoadData = true;
          }
      },
      handleAvatarSuccess(res, file) {
        // 上传成功后的处理逻辑
        this.certificateList.push({
            url: res.data.url,
        });
      },
      handleRemove(file, fileList) {
        // 删除文件后的处理逻辑
        this.certificateList = this.certificateList.filter((item) => item.url !== file.url);
      },
      handleAvatarSuccess2(res, file) {
        // 上传成功后的处理逻辑
        this.cardNoList.push({
            url: res.data.url,
        });
      },
      handleRemove2(file, fileList) {
        // 删除文件后的处理逻辑
        this.cardNoList = this.cardNoList.filter((item) => item.url !== file.url);
      },
      handleAvatarSuccess3(res, file) {
        // 上传成功后的处理逻辑
        this.bankLicenseList.push({
            url: res.data.url,
        });
      },
      handleRemove3(file, fileList) {
        // 删除文件后的处理逻辑
        this.bankLicenseList = this.bankLicenseList.filter((item) => item.url !== file.url);
      },
      handleAvatarSuccess4(res, file) {
        // 上传成功后的处理逻辑
        this.dateList.push({
            url: res.data.url,
        });
      },
      handleRemove4(file, fileList) {
        // 删除文件后的处理逻辑
        this.dateList = this.dateList.filter((item) => item.url !== file.url);
      },
      handlePictureCardPreview(file) {
        // 预览图片
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      beforeAvatarUpload(file) {
        // 上传前的处理逻辑
        // const isJPG = file.type === 'image/jpeg';
        // if (!isJPG) {
        //   this.$message.error('上传图片只能是 JPG 格式!');
        // }
        // return isJPG;
      },
      handleSizeChange (val) { //每页显示条数
          this.pageSize = val;
          this.currentPage = 1;
          this.getList();
      },
      handleCurrentChange(val) { //当前页
          this.currentPage = val;
          this.getList(); //获取列表
      },
      handleSizeChange1 (val) { //每页显示条数
          this.pageSize1 = val;
          this.currentPage1 = 1;
          this.getListApply();
      },
      handleCurrentChange1(val) { //当前页
          this.currentPage1 = val;
          this.getListApply(); //获取列表
      },
      getListApply(){
        //获取列表
        let that = this;
        let param = {};
        param.page = this.currentPage1;
        param.pageSize = this.pageSize1;
        param.rentalType = that.formInline1.rentalType;
        param.name = that.formInline1.name;
        if(that.formInline1.date && that.formInline1.date.length > 0){
          param.start = that.formInline1.date[0];
          param.end = that.formInline1.date[1];
        }
        that.$axios.post(that.$store.state.platformApi+"tenant/page/0",JSON.stringify(param)).then(result => {
          if(result.code==200){
            that.tableData1 = result.data.records;
            that.total1 = result.data.total;
          }
        })
      },
      searchApply(){
        let that = this;
        let param = {};
        param.page = 1;
        param.pageSize = this.pageSize1;
        param.rentalType = that.formInline1.rentalType;
        param.name = that.formInline1.name;
        if(that.formInline1.date && that.formInline1.date.length > 0){
          param.start = that.formInline1.date[0];
          param.end = that.formInline1.date[1];
        }
        that.$axios.post(that.$store.state.platformApi+"tenant/page/0",JSON.stringify(param)).then(result => {
          if(result.code==200){
            that.tableData1 = result.data.records;
            that.total1 = result.data.total;
          }
        })
      },
      search(){
        //搜索
        let that = this;
        let param = {};
        param.page = 1;
        param.pageSize = this.pageSize;
        param.state = that.formInline.state;
        param.rentalType = that.formInline.rentalType;
        param.name = that.formInline.name;
        if(that.formInline.date && that.formInline.date.length > 0){
          param.start = that.formInline.date[0];
          param.end = that.formInline.date[1];
        }
        that.$axios.post(that.$store.state.platformApi+"tenant/page/1",JSON.stringify(param)).then(result => {
          if(result.code==200){
            that.tableData = result.data.records;
            that.total = result.data.total;
          }
        })
      },
      getList(){
        //获取列表
        let that = this;
        let param = {};
        param.page = this.currentPage;
        param.pageSize = this.pageSize;
        param.state = that.formInline.state;
        param.rentalType = that.formInline.rentalType;
        param.name = that.formInline.name;
        if(that.formInline.date && that.formInline.date.length > 0){
          param.start = that.formInline.date[0];
          param.end = that.formInline.date[1];
        }
        that.$axios.post(that.$store.state.platformApi+"tenant/page/1",JSON.stringify(param)).then(result => {
          if(result.code==200){
            that.tableData = result.data.records;
            that.total = result.data.total;
          }
        })
      },
      saveInfo(){
        //保存
        let that = this;
        // 表单校验
        this.$refs.signInfoRef.validate((valid) => {
          if (!valid) return;
          let param = {};
          var url = that.$store.state.platformApi+"tenant/edit";
          param = this.signInfo;
          if(!that.signInfo.date || that.signInfo.date.length === 0){
            that.$message.error('请选择租用时间范围');
            return;
          }else{
            param.rentalStart = that.signInfo.date[0];
            param.rentalEnd = that.signInfo.date[1];
          }
          if(this.certificateList && this.certificateList.length > 0){
            param.certificateUrl = this.certificateList.map(item => item.url).join(',');
          }
          if(this.bankLicenseList && this.bankLicenseList.length > 0){
            param.bankLicense = this.bankLicenseList.map(item => item.url).join(',');
          }
          if(this.cardNoList && this.cardNoList.length > 1){
            param.cardFront = this.cardNoList[0].url;
            param.cardBack = this.cardNoList[1].url;
          }else{
            that.$message.error('请上传身份证正反面照片');
            return;
          }
          if(this.dateList && this.dateList.length > 0){
            param.signProtocol = this.dateList.map(item => item.url).join(',');
          }
          
          that.$axios.post(url,JSON.stringify(param)).then(result => {
            if(result.code==200){
              // 保存成功
              that.dialogFormVisible = false;
              that.getList();
            }
          })
        });
      },
      handleEdit(index,row){
        //打开编辑
        this.isUpdate = true;
        this.dialogFormVisible = true;
        this.signInfo = JSON.parse(JSON.stringify(row));
        this.changeRentalalType();
        setTimeout(() => {
          this.signInfo.rentalTerm = row.rentalTerm || '';
        }, 100);
        this.signInfo.date = [];
        this.dateList = [];
        this.bankLicenseList = [];
        this.cardNoList = [];
        this.certificateList = [];
        if(this.signInfo.rentalStart && this.signInfo.rentalEnd){
          this.signInfo.date = [this.signInfo.rentalStart, this.signInfo.rentalEnd];
        }
        if(this.signInfo.signProtocol!=''){
          this.dateList = this.signInfo.signProtocol.split(',').map(item => ({
                url: item,
          }));
        }
        if(this.signInfo.bankLicense!=''){
          this.bankLicenseList = this.signInfo.bankLicense.split(',').map(item => ({
                url: item,
          }));
        }
        if(this.signInfo.cardFront!=''){
          this.cardNoList = this.signInfo.cardFront.split(',').map(item => ({
                url: item,
          }));
        }
        if(this.signInfo.cardBack!=''){
          this.cardNoList.push({
            url: this.signInfo.cardBack,
          });
        }
        if(this.signInfo.certificateUrl!=''){
          this.certificateList = this.signInfo.certificateUrl.split(',').map(item => ({
                url: item,
          }));
        }
      },
      handleStart(index,row){
        //启用弹窗
        this.centerDialogVisible = true;
        this.currt_id = row.id;
      },
      handleStop(index,row){
        //停用弹窗
        this.centerDialogVisible2 = true;
        this.currt_id = row.id;
      },
      rentalTypeFilter(value) {
        //过滤函数
        switch (value) {
          case 1:
            return '月租';
          case 2:
            return '年租';
          default:
            return '其他';
        }
      },
      typeFilter(value) {
        //过滤函数
        switch (value) {
          case 1:
            return '公司/企业';
          case 2:
            return '个体工商户';
          default:
            return '其他';
        }
      },
      statusFilter(value) {
        //过滤函数
        switch (value) {
          case 0:
            return '未启用';
          case 1:
            return '启用中';
          case 2:
            return '已停用';
          default:
            return '其他';
        }
      }
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .search_nav{
      width: 100%;
      height: 60px;
  }
  /* 当 .hide-upload-btn 类存在时，隐藏上传按钮 */
  .hide-upload-btn ::v-deep .el-upload--picture-card {
    display: none;
  }
  </style>